import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        tinymce.init({
            selector: "#"+this.element.id,
            plugins: ['lists','link','fullscreen','code'],
            menubar: '',
            promotion: false,
            branding: false,
            block_unsupported_drop: true,
            images_file_types: "",
            toolbar: [
                { name: 'history', items: [ 'undo', 'redo' ] },
                { name: 'styles', items: [ 'styles' ] },
                { name: 'formatting', items: [ 'bold', 'italic' ] },
                { name: 'alignment', items: [ 'alignleft', 'aligncenter', 'alignright', 'alignjustify' ] },
                { name: 'indentation', items: [ 'outdent', 'indent' ] },
                { name: 'content', items: [ 'bullist','link' ] },
                { name: 'fullscreen', items: [ 'code','fullscreen' ] }
            ]
        });
    }

    disconnect() {
        super.disconnect();
    }
}
